/** Default warehouse filter from `user.tranzit` (string in the model); 0 — all warehouses. */
export const getDefaultWarehouseID = (tranzit: string | number | null | undefined): number => {
    const id = Number(tranzit)
    return Number.isFinite(id) ? id : 0
}

/** Number stored in sessionStorage under `key`; not stored yet — `fallback`, non-numeric — 0. */
export const readSessionNumber = (key: string, fallback = 0): number => {
    const value = sessionStorage.getItem(key)
    return value !== null ? +value || 0 : fallback
}
